<script setup>
defineProps({
  components: { type: Array, required: true },
  tag: { type: String, required: false, default: "div" }
});
const getComponent = (name) => {
  return "Cms" + name.charAt(0).toUpperCase() + name.slice(1);
};
</script>

<template>
  <component :is="tag">
    <component :is="getComponent(component.name)" v-for="component in components" :key="component.id"
      v-bind="component.props" />
  </component>
</template>
